﻿import {OpenAIRealtimeWebRTC, RealtimeAgent, RealtimeItem, RealtimeSession, tool} from "@openai/agents-realtime";
import {Sounds} from "../Sounds";
import {Delay} from "../Async";

let Agent: RealtimeAgent;
let Session: RealtimeSession | null;
let Status: string;
let Prompt: string;
let Dotnet: any;
let Model: string;
let Voice: string;
let Cost: number;
let Append: RealtimeItem[] = [];
let Sent: string[] = [];

async function Connect(apiKey: string, prompt: string, model: string, voice: string, voiceSpeed: number, tools: string, dotnet: any) {

    console.log("Connect", prompt, model, voice, voiceSpeed, tools);
    
    Cost = 0;
    Prompt = prompt;
    Dotnet = dotnet;
    Model = model;
    Voice = voice;
    Agent = new RealtimeAgent({
        name: 'Kai',
        instructions: prompt,
        tools: Tools(tools),
        voice: voice
    });
    
    const audioPlayer = document.getElementById("openAiSpeach") as HTMLAudioElement;

    const webrtc = new OpenAIRealtimeWebRTC({
        baseUrl: "https://" + document.location.host + "/calls",
        audioElement: audioPlayer,
        apiKey: apiKey
    });

    Session = new RealtimeSession(Agent, {
        model: model,
        config: {
            model: model, 
            voice: voice, 
            speed: voiceSpeed,
            instructions: prompt,
            tools: Tools(tools),
            audio: { 
                input: { 
                    turnDetection: {                        
                        type: "semantic_vad",
                        threshold: 0.85,
                        silence_duration_ms: 1000,
                        prefix_padding_ms: 400,
                        eagerness: "low"
                    }
                },
                output: {
                    speed: voiceSpeed,
                    voice: voice
                }
            }
        },
        transport: webrtc
    });
    window.Session = Session;

    Session.on("history_updated", OnHistoryUpdated);
    Session.on("history_added", OnHistoryAdded);
    Session.on("agent_tool_start", OnAgentToolStart);
    Session.on("agent_tool_end", OnAgentToolEnd);
    Session.on("agent_handoff", OnAgentHandoff);
    Session.on("guardrail_tripped", OnGuardrailTripped);
    Session.on("transport_event", OnTransportEvent);


    // Status updating
    Session.on('transport_event', (e) => {
        switch (e.type) {
            case 'connection.open': OnStatusChanged('Listening'); break;
            case 'connection.closed': OnStatusChanged('Disconnected'); break;
            case 'session_created': OnStatusChanged('Listening'); break;
            case 'output_audio_buffer.started': OnStatusChanged('Speaking'); break;
            case 'output_audio_buffer.stopped': 
                OnStatusChanged('Listening');
                OnSendPending();
                break;
        }
    });

    OnStatusChanged('Connecting');
    try {
        await Session.connect({ apiKey: apiKey });        
        OnStatusChanged('Listening');
        await Delay(100);
        Sounds.Beep();
    }
    catch (e) {
        console.error(e);
        OnStatusChanged('Disconnected');
        return;
    }
}


function OnStatusChanged(status: string) {
    if (status == Status) return;
    console.log("[Status] " + status);
    Status = status;
    Dotnet.invokeMethodAsync("OnStatusChanged", status);
    if (Status == "Disconnected") Sounds.Beep();
}

async function OnHistoryUpdated(event: RealtimeItem[]) {
        
    for (const item of event) {
        let status = (item as any)["status"];
        let role = (item as any)["role"];
        let transcript = (((item as any)["content"] || {})[0] || {})["transcript"];
        if (status == "in_progress") break;
        if (role == "user" && transcript === null) break;
        
        if (Sent.includes(item.itemId)) continue;
        Sent.push(item.itemId);
        
        console.log("Send: " + JSON.stringify(item));
        Dotnet.invokeMethodAsync("OnConversationItemAdded", item);
    }
    
    console.log("OnHistoryUpdated", event); 
}

function OnHistoryAdded(event: any) {
    // console.log("OnHistoryAdded", event);
}

function OnAgentToolStart(event: any) {
    console.log("OnAgentToolStart", event);
}

function OnAgentHandoff(event: any) {
    console.log("OnAgentHandoff", event);
}

function OnGuardrailTripped(event: any) {
    console.log("OnGuardrailTripped", event);
}

function OnAgentToolEnd(event: any) {
    console.log("OnAgentToolEnd", event);
}

function OnTransportEvent(event: any) {
        
    if (event.type === "conversation.item.input_audio_transcription.delta") return;
    if (event.type === "response.audio_transcript.delta") return;

    if (event.type == "response.done") {
        const r = event.response;
        // console.log(r);
        // console.log('[response.done]', r?.status, r?.status_details);
    }
    
   // console.log(event.type, event);    
}

function Tools(tools: any){
    return JSON.parse(tools).map((t: { name: any; description: any; parameters: any; }) => (
        tool({
            name: t.name,
            description: t.description,
            parameters: t.parameters,
            execute: async (params: any) => {
                return await Dotnet.invokeMethodAsync("OnToolExecute", t.name, JSON.stringify(params));
            },
        })));
}

async function Update(prompt: string, tools: string, clearHistory: boolean): Promise<void> {
    if (!Session) return;

    try {

        console.log("Update", prompt, tools, clearHistory);
        
        /*const agent = new RealtimeAgent({
            name: 'Kai',
            instructions: prompt || Agent.instructions.toString(),
            tools: (tools == null) ? Agent.tools : Tools(tools),
            voice: Agent.voice
        });*/
        
        if (clearHistory) Session.updateHistory([]);
        
        //await Session?.updateAgent(agent);
        //Agent = agent;

        Session?.transport.sendEvent({
            type: 'session.update',
            session: {
                type: 'realtime',
                instructions: prompt,
                tools: (tools == null) ? Agent.tools : Tools(tools)
            }
        });
    }
    catch (e) {
        console.error(e);
    }
}

function OnSendPending() {
    if (Append == null || Append.length == 0) return;
    
    const items = Append;
    Append = [];
    
    for (const item of items) {
        Session?.transport.sendEvent({
            type: "conversation.item.create",
            item: item
        });
    }
}

async function Send(role: string, text: string): Promise<void> {
    if (!Session) return;
    
    if (role == "tool"){
        console.error("Sending tool calls is not supported");
        return;
    }
    
    try {

        console.log("Send", role, text);

        Append.push({
            type: "message",
            // @ts-ignore
            role: role,
            status: "completed",
            content: [{type: "input_text", text: text}]
        });
        
        if (Status == "Listening"){
            OnSendPending();
        }
    }
    catch (e) {
        console.error(e);
    }
}

function Respond(phrase: string){
    if (phrase == null) Session?.transport.sendEvent({ type: "response.create", response: { }});
    else Session?.transport.sendEvent({ type: "response.create", response: {"instructions": "Say this: \"" + phrase + "\".", "input": []} });
}

function Mute(muted: boolean){
    if (Session == null) return;
    Session.mute(muted);   
}

async function Disconnect(): Promise<void> {
    if (!Session) return;

    try {
        Session?.close();
    }
    catch (e) {
        console.error(e);
    }
    Session = null;
    OnStatusChanged('Disconnected');
}

declare global {
    interface Window {
        Session?: RealtimeSession;
    }
}

export const OpenAIVoiceAgent = {
    Connect,
    Update,
    Send,
    Disconnect,
    Respond,
    Mute
}

const Prices = {
    "gpt-realtime": {
        text: { input: 4.00, cached: 0.40, output: 16.00 },
        audio: { input: 32.00, cached: 0.40, output: 64.00 },
        image: { input: 5.00, cached: 0.50 },
    },
    "gpt-4o-mini-realtime-preview": {
        text: { input: 0.60, cached: 0.30, output: 2.40 },
        audio: { input: 10.00, cached: 0.30, output: 20.00 },
    },
} as const;